import { render, staticRenderFns } from "./newSupper.vue?vue&type=template&id=1d27a655&scoped=true&"
import script from "./newSupper.vue?vue&type=script&lang=js&"
export * from "./newSupper.vue?vue&type=script&lang=js&"
import style0 from "./newSupper.vue?vue&type=style&index=0&id=1d27a655&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d27a655",
  null
  
)

export default component.exports